// import logo from './logo.svg';
import {Provider} from 'react-redux';
import './fonts/index';
import './App.css';
import {AppNavigator} from 'navigation';
import {store} from 'store';
import {useEffect} from 'react';

// TODO: Replace the following with your app's Firebase project configuration
// See: https://firebase.google.com/docs/web/learn-more#config-object

function App() {
  useEffect(() => {
    console.log('a', process.env.NODE_ENV, process.env.REACT_APP_ENV);
    if (process.env.REACT_APP_ENV === 'PROD') {
      console.log = () => {};
      console.debug = () => {};
      console.error = () => {};
    }
    console.log('STARTING IN DEV MODE');
    // if(process.env.NODE_ENV)
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        {/* <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.tsx</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a> */}
        <Provider store={store}>
          <AppNavigator />
        </Provider>
      </header>
    </div>
  );
}

export default App;
